import { useState } from "react";
import { Link } from "react-router-dom";

import SideBar from "../../components/ThirdPartyDashboard/SideBar";
import "../../styles/ThirdParty/Verification.scss";
import { useEffect } from "react";
import Search from "../../components/ThirdPartyDashboard/Search";
import {
  getPlantsData as greenBasicGetAllEmissionData,
  getStaticAttributes as greenBasicGetStaticAttributes,
  getThreeMonthUnverifiedAccumulations as greenBasicGetThreeMonthAccumulations,
} from "../../instantiateTransaction/basicGreenProject";
import {
  getPlantsData as infraBasicGetAllEmissionData,
  getStaticAttributes as infraBasicGetStaticAttributes,
} from "../../instantiateTransaction/basicInfrastructureChange";
import {
  getPlantsData as greenGovernanceGetAllEmissionData,
  getStaticAttributes as greenGovernanceGetStaticAttributes,
} from "../../instantiateTransaction/governanceGreenProject";
import {
  getPlantsData as infraGovernanceGetAllEmissionData,
  getStaticAttributes as infraGovernanceGetStaticAttributes,
} from "../../instantiateTransaction/gorvernanceInfrastructureChange";
import {
  getPlantsData as governanceMonitoringGetAllEmissionData,
  getStaticAttributes as governanceMonitoringGetStaticAttributes,
} from "../../instantiateTransaction/governanceCarbonMonitoring";
import { toast } from "react-toastify";
import { ethers } from "ethers";
import { getDatabase, ref, onValue, push } from "firebase/database";
import moment from "moment";
import { facilityVerify ,getCommentById} from "../../apis/General/web3/shared";
import { useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Illustration from "../../images/9264828.jpg";
import { getKyc } from "../../apis/General/users";
import { Tab, Tabs } from "@mui/material";
import { getThreeMonthUnverifiedAccumulations ,getAllPlantsThreeMonthCards} from "../../instantiateTransaction/basicGreenProject";
import { getThreeMonthUnverifiedAccumulationsAll } from "../../instantiateTransaction/basicGreenProject";
import {  getAllPlantsThreeMonthCards as getAllPlantsThreeMonthCardsNonGreen} from "../../instantiateTransaction/basicInfrastructureChange";

import Kyc from "../../components/ThirdPartyDashboard/Kyc";
import VerificationProjectCard from "../../components/ThirdPartyDashboard/VerificationProjectCard";

/**
 * 
 * @param {number} index 
 * @returns 
 */
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Verification = () => {
  const auth = useSelector((state) => state.auth);
  // console.log("auth", auth);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpen2, setModalOpen2] = useState(false);
  const [reason, setReason] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [rejectLoading, setRejectLoading] = useState(false);
  const [content, setContent] = useState("");
  const [showForm, setShowForm] = useState(false);

  const [modalOpenTwo, setModalOpenTwo] = useState(false);
  const [totalEmission, setTotalEmission] = useState(0);
  const [open, setOpen] = useState(0);
  const [loading, setLoading] = useState(false);
  const [generalLoading, setGeneralLoading] = useState(false);
  const [selectedFacility, setSelectedFacility] = useState([]);
  const [activities, setActivities] = useState([]);
  const [selectedKyc, setSelectedKyc] = useState("");
  const [currentIndex, setCurrentIndex] = useState(null);
  const [selectedStaticAttributes, setSelectedStaticAttributes] = useState("")
  const [selectedSubscriptionPlan, setSelectedSubscriptionPlan] = useState("");

  const [value, setValue] = useState(0);
  const [comments, setComments] = useState([]);
  const [commentText, setCommentText] = useState("");

  const [greenBasicFacilitiesVerified, setGreenBasicFacilitiesVerified] = useState([]);
  const [greenBasicFacilitiesUnverified, setGreenBasicFacilitiesUnverified] = useState([]);
  const [infraBasicFacilitiesVerified, setInfraBasicFacilitiesVerified] = useState([]);
  const [infraBasicFacilitiesUnverified, setInfraBasicFacilitiesUnverified] = useState([]);
  const [greenGovernanceFacilitiesVerified, setGreenGovernanceFacilitiesVerified] = useState([]);
  const [greenGovernanceFacilitiesUnverified, setGreenGovernanceFacilitiesUnverified] = useState([]);
  const [infraGovernanceFacilitiesVerified, setInfraGovernanceFacilitiesVerified] = useState([]);
  const [infraGovernanceFacilitiesUnverified, setInfraGovernanceFacilitiesUnverified] = useState([]);
  const [monitoringVerified, setMonitoringVerified] = useState([]);
  const [monitoringUnverified, setMonitoringUnverified] = useState([]);
  const [verifiedLength, setVerifiedLength] = useState(0);
  const [unVerifiedLength, setUnVerifiedLength] = useState(0);
  const [commmentsLength, setCommmentsLength] = useState(0);
  // state for new flow
  const [UnverifiedData, setUnverifiedData] = useState([]);
  const [NonGreenUnverifiedData, setNonGreenUnverifiedData] = useState([]);
  const [DataData, setDataData] = useState([]); // New state for non-green unverified data
  const [facilityType, setFacilityType] = useState("green");
  const [plantAddressData, setPlantAddressData] = useState("");

  const [show, setShowVerify] = useState(false);
  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const getUnverifiedGreeData = async () => {
    try {
      // Fetch green unverified data
      const result = await getAllPlantsThreeMonthCards();
      setUnverifiedData(result?.[0].cards || []);

      // You'll need to add a similar function for non-green projects
      // For now, using the existing infrastructure unverified data
      setDataData([
        ...infraBasicFacilitiesUnverified,
        ...infraGovernanceFacilitiesUnverified
      ]);

      console.log("Three Month Unverified Accumulations:", result);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };
  const getUnverifiedNonGreen = async () => {
    try {
      // Fetch non-green unverified data
      const result = await getAllPlantsThreeMonthCardsNonGreen(0, 10);
      setNonGreenUnverifiedData(result?.[0].cards || []);
      console.log("Three Month Unverified Non-Green Accumulations:", result);

    } catch (err) {
      console.error("Error fetching non-green data:", err);
    }
  }
  const getValidationData = async () => {
    setGeneralLoading(true);
    try {
      const response6 = await greenBasicGetAllEmissionData(0, 20);
      console.log("response6", response6);

      const temp1 = response6?.getAllInfo?.filter((item) => !!item?.isVerified)
      const temp2 = response6?.getAllInfo?.filter((item) => !item?.isVerified)
      setGreenBasicFacilitiesVerified(temp1);
      setGreenBasicFacilitiesUnverified(temp2);

      const response7 = await infraBasicGetAllEmissionData(0, 20);
      console.log("response7", response7);

      const temp3 = response7?.getAllInfo?.filter((item) => !!item?.isVerified)
      const temp4 = response7?.getAllInfo?.filter((item) => !item?.isVerified)

      setInfraBasicFacilitiesVerified(temp3);
      setInfraBasicFacilitiesUnverified(temp4);

      const response8 = await greenGovernanceGetAllEmissionData(0, 20);

      const temp5 = response8?.getAllInfo?.filter((item) => !!item?.isVerified)
      const temp6 = response8?.getAllInfo?.filter((item) => !item?.isVerified)

      setGreenGovernanceFacilitiesVerified(temp5);
      setGreenGovernanceFacilitiesUnverified(temp6);

      const response9 = await infraGovernanceGetAllEmissionData(0, 20);

      const temp7 = response9?.getAllInfo?.filter((item) => !!item?.isVerified)
      const temp8 = response9?.getAllInfo?.filter((item) => !item?.isVerified)

      setInfraGovernanceFacilitiesVerified(temp7);
      setInfraGovernanceFacilitiesUnverified(temp8);

      const response10 = await governanceMonitoringGetAllEmissionData(0, 20);

      const temp9 = response10?.getAllInfo?.filter((item) => !!item?.isVerified)
      const temp10 = response10?.getAllInfo?.filter((item) => !item?.isVerified)

      setMonitoringVerified(temp9);
      setMonitoringUnverified(temp10);

      setVerifiedLength(
        temp1?.length +
        temp3?.length +
        temp5?.length +
        temp7?.length +
        temp9?.length
      )

      setUnVerifiedLength(
        temp2?.length +
        temp4?.length +
        temp6?.length +
        temp8?.length +
        temp10?.length
      )
    } catch (error) {
      console.log("ERROR", error);
    }
    setGeneralLoading(false);
  };



  const getActivities = async () => {
    const database = getDatabase();
    const newRef = ref(database, "events");
    await onValue(newRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setActivities(Object.values(data));
      }
    });
  };

  const addComment = () => {
    const trimmed = commentText.trim();
    if (!trimmed) return;
    setComments((prev) => [
      ...prev,
      { text: trimmed, createdAt: new Date().toISOString() },
    ]);
    setCommentText("");
  };


  const getLastActivity = (address) => {
    const filteredData = activities?.filter(
      (item) =>
        item?.addressToRecord === address && item?.type === "Plant Verified"
    );
    const lastData = filteredData[filteredData.length - 1];
    if (filteredData?.length > 0) {
      return `${lastData?.type}, by ${lastData?.addressToRecord} on ${moment(
        parseInt(lastData?.timestamp) * 1000
      ).format("Do MMM YYYY")} at ${moment(
        parseInt(lastData?.timestamp) * 1000
      ).format("hh:mm A")}`;
    } else {
      return "No Verification has been carried out for this facility";
    }
  };

  const handleVerification = async (facility) => {
    setLoading(true);
    let response;
    try {
      if (
        facility?.scenario?.toLowerCase() === "green" && selectedSubscriptionPlan === "basic"
      ) {
        response = await facilityVerify(
          "green",
          "basic",
          facility?.plantAddress,
          auth?.token
        );
      }
      else if (
        facility?.scenario === "infrastructure-change" && selectedSubscriptionPlan === "basic"
      ) {
        response = await facilityVerify(
          "infrastructure-change",
          "basic",
          facility?.plantAddress,
          auth?.token
        );
      } else if (
        facility?.scenario?.toLowerCase() === "green" && selectedSubscriptionPlan === "governance"
      ) {
        response = await facilityVerify(
          "green",
          "governance",
          facility?.plantAddress,
          auth?.token
        );
      } else if (
        facility?.scenario === "infrastructure-change" && selectedSubscriptionPlan === "governance"
      ) {
        response = await facilityVerify(
          "infrastructure-change",
          "governance",
          facility?.plantAddress,
          auth?.token
        );
      }
      else if (facility?.scenario === "carbon-monitoring") {
        response = await facilityVerify(
          "carbon-monitoring",
          "governance",
          facility?.plantAddress,
          auth?.token
        );
      }
      else {
        alert("Invalid Scenario");
        setLoading(false);
        return;
      }
      console.log('verification response', response);

      if (response?.data?.statusCode === 200) {
        toast.success("Verification Successful");
        setModalOpen(false);
        setShowForm(false);
        getValidationData();
      } else if (response?.data?.errorMessage) {
        toast.error(response?.data?.errorMessage);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.log("ERROR", error);
    }
    setLoading(false);
  };

  const sets = async (facility, index, subscriptionPlan) => {
    setCurrentIndex(index);
    setLoading(true);
    setSelectedSubscriptionPlan(subscriptionPlan)
    try {
      console.log("facility", facility, "subscriptionPlan", subscriptionPlan, facility?.scenario, facility?.scenario === "infrastructure-change");
      setSelectedFacility(facility);
      let response;
      if (
        facility?.scenario === "infrastructure-change" &&
        subscriptionPlan === "basic"
      ) {
        response = await infraBasicGetStaticAttributes(facility?.plantAddress);
      } else if (
        facility?.scenario === "green" &&
        subscriptionPlan === "basic"
      ) {
        response = await greenBasicGetStaticAttributes(facility?.plantAddress);
      } else if (
        facility?.scenario === "infrastructure-change" &&
        subscriptionPlan === "governance"
      ) {
        response = await infraGovernanceGetStaticAttributes(facility?.plantAddress);
      } else if (
        facility?.scenario === "green" &&
        subscriptionPlan === "governance"
      ) {
        response = await greenGovernanceGetStaticAttributes(facility?.plantAddress);
      } else if (facility?.scenario === "carbon-monitoring") {
        response = await governanceMonitoringGetStaticAttributes(
          facility?.plantAddress
        );
      } else {
        alert("Invalid Scenario");
      }
      console.log("response static", response);
      const response2 = await getKyc(
        facility?.scenario === "green" && subscriptionPlan === "basic"
          ? response?.staticAttributes[5] :
          facility?.scenario === "infrastructure-change" && subscriptionPlan === "basic"
            ? response?.staticAttributes[6] :
            facility?.scenario === "green" && subscriptionPlan === "governance"
              ? response?.staticAttributes[7] :
              facility?.scenario === "infrastructure-change" && subscriptionPlan === "governance"
                ? response?.staticAttributes[7] :
                response?.staticAttributes[7],
        auth?.token
      );
      console.log("response2", response2);
      setSelectedStaticAttributes(response?.staticAttributes);
      setSelectedKyc(response2?.data?.message);
      setModalOpen(true);
    } catch (error) {
      console.log("ERROR", error);
      toast.error("Something went wrong");
    }
    setLoading(false);
  };

  const handleModalClose = (e) => {
    if (e.target.classList.contains("modal") || e.target.classList.contains("validation-modal")) {
      setModalOpen(false);
      // setModalOpenTwo(false);
    }
  };
    const userId = "UN9ujbCjkMHfmgKWhM38maR4";

  const getCommentByUserId = async (userId) => {
  // Validation
  if (!userId) {
    console.error("User ID is required");
    return null;
  }

  if (!auth?.token) {
    console.error("No authentication token available");
    return null;
  }

  try {
    const comment = await getCommentById(userId, auth.token);
    console.log("COMMENTRESULT", comment);
    return comment;
  } catch (error) {
    console.error("Error fetching comment for user:", userId, error);
    // You might want to handle different error types differently
    if (error.response?.status === 404) {
      console.log("Comment not found for user:", userId);
    } else if (error.response?.status === 401) {
      console.log("Authentication failed");
      // Maybe redirect to login
    }
    return null; // or throw error depending on your needs
  }
};
  //   const getThreeMonthUnverifiedAccumulationsForPlantData = async (plantAddress) => {
  //     try {
  //       const result = await getThreeMonthUnverifiedAccumulationsForPlant(plantAddress);
  // console.log("Three Month Unverified Accumulations for Plant:", result);

  //       return result;
  //     } catch (err) {
  //       console.error("Error fetching data for plant:", err);
  //   }
  //   }


  useEffect(() => {
  getCommentByUserId()
    // getThreeMonthUnverifiedAccumulationsForPlantData();
    getUnverifiedNonGreen();
    getUnverifiedGreeData();
    getUnverifiedGreeData()
    getValidationData();
    getActivities();
  }, []);


  if (show) return (
    <div> show</div>
  )

  return (
    <div className="thirdparty_verification">
      <div className="sidebar_container">
        <SideBar />
      </div>

      <div className="main">
        <Search />
        <Tabs
          value={value}
          onChange={handleTabChange}
          aria-label="project tabs"
          className="tab_label_container"
        >
          <Tab
            className={value === 0 ? "tab_label tab_active" : "tab_label"}
            label={
              <div className="tab-label-content">
                <span>Unverified Projects</span>
                {unVerifiedLength > 0 && <span className="tab-label-content__count">{unVerifiedLength}</span>}
              </div>
            }
            {...a11yProps(0)}
          />
          <Tab
            className={value === 1 ? "tab_label tab_active" : "tab_label"}
            label={
              <div className="tab-label-content">
                <span>Verified Projects</span>
                {verifiedLength > 0 && <span className="tab-label-content__count">{verifiedLength}</span>}
              </div>
            }
            {...a11yProps(1)}
          />
          <Tab
            className={value === 2 ? "tab_label tab_active" : "tab_label"}
            label={
              <div className="tab-label-content">
                <span>Comments</span>
                {commmentsLength > 0 && <span className="tab-label-content__count">{commmentsLength}</span>}
              </div>
            }
            {...a11yProps(2)}
          />
        </Tabs>

        {/* Facility Type Filter - Only show for Unverified tab & Comments tab */}
        {(value === 0 || value === 2) && (
          <div className="flex flex-row items-start pb-5 pt-3 pl-3 gap-4 w-[276px] h-[50px] bg-[#F0F2F5] rounded-lg mb-5 ">
            {/* Green Button */}
            <button
              className={`flex flex-row justify-center items-center p-2 gap-3 w-[111px] h-[40px] box-border ${facilityType === "green"
                  ? "bg-white border border-[#006633] shadow-[-2px_2px_2px_rgba(0,174,217,0.05)] rounded-lg"
                  : "bg-transparent border-transparent rounded-lg"
                }`}
              onClick={() => setFacilityType("green")}
            >
              <div className="flex flex-row items-center gap-1.5 w-[77px] h-6">
                <span className={`w-[47px] h-6 font-inter font-medium text-[16px] leading-6 ${facilityType === "green" ? "text-[#101828]" : "text-[#98A2B3]"
                  }`}>
                  Green
                </span>
                <div className={`flex flex-col justify-center items-center p-5 gap-2.5 w-6 h-6 rounded-full ${facilityType === "green" ? "bg-[#006633]" : "bg-[#98A2B3]"} }`}>
                  <span className=" h-6 font-inter font-medium text-[16px] leading-6 text-white ">
                    {Object.keys(UnverifiedData || {}).length}
                  </span>
                </div>
              </div>
            </button>

            {/* Non-green Button */}
            <button
              className={`flex flex-row justify-center items-center p-2 gap-3 w-fit min-w-[133px] h-[40px] box-border ${facilityType === "non-green"
                  ? "bg-white border border-[#006633] shadow-[-2px_2px_2px_rgba(0,174,217,0.05)] rounded-lg"
                  : "bg-transparent border-transparent rounded-lg"
                }`}
              onClick={() => setFacilityType("non-green")}
            >
              <div className="flex flex-row items-center gap-1.5 w-fit min-w-[117px] h-6">
                <span className={`min-w-[87px] h-6 font-inter font-medium text-[16px] leading-6 ${facilityType === "non-green" ? "text-[#101828]" : "text-[#98A2B3]"
                  }`}>
                  Non-green
                </span>
                <div className={`flex flex-col justify-center items-center p-5 gap-2.5 w-6 h-6 rounded-full ${facilityType === "non-green" ? "bg-[#006633]" : "bg-[#98A2B3]"
                  }`}>
                  <span className=" h-6 font-inter font-medium text-[16px] leading-6 text-white">
                    {Object.keys(NonGreenUnverifiedData || {}).length}

                  </span>
                </div>
              </div>
            </button>
          </div>
        )}

        {!generalLoading &&
          value === 1 &&
          greenBasicFacilitiesVerified?.length === 0 &&
          infraBasicFacilitiesVerified?.length === 0 &&
          greenGovernanceFacilitiesVerified?.length === 0 &&
          infraGovernanceFacilitiesVerified?.length === 0 &&
          monitoringVerified?.length === 0 && (
            <div className="empty_list">
              <img src={Illustration} alt="" />
              <div>No verification data here yet</div>
            </div>
          )}

        {!generalLoading &&
          value === 0 &&
          facilityType === "green" &&
          Object.keys(UnverifiedData || {}).length === 0 && (
            <div className="empty_list">
              <img src={Illustration} alt="" />
              <div>No unverified green projects</div>
            </div>
          )}

        {!generalLoading &&
          value === 0 &&
          facilityType === "non-green" &&
          NonGreenUnverifiedData?.length === 0 && (
            <div className="empty_list">
              <img src={Illustration} alt="" /> 
              <div>No unverified non-green projects</div>
            </div>
          )}

        {/* Green Unverified Projects */}
        {value === 0 && facilityType === "green" && Object.entries(UnverifiedData || {}).reverse().map(([plantAddress, facility]) => (
          <VerificationProjectCard key={plantAddress} facility={facility} link={`/third-party/web3/${plantAddress}`} loading={loading} />
        ))}

        {/* Non-green Unverified Projects */}
        {value === 0 && facilityType === "non-green" && Object.entries(NonGreenUnverifiedData || {}).reverse().map(([plantAddress, facility]) => (
          <VerificationProjectCard key={plantAddress} facility={facility} link={`/third-party/non-green/web3/${plantAddress}`} loading={loading} />
        ))}

        {/* Green Comments */}
        {value === 2 && facilityType === "green" && Object.entries(UnverifiedData || {}).map(([plantAddress, facility]) => (
          <VerificationProjectCard key={plantAddress} facility={facility} link={`/third-party/web3/${plantAddress}`} loading={loading} isComment={true} />
        ))}

        {/* Non-green Comments */}
        {value === 2 && facilityType === "non-green" && Object.entries(NonGreenUnverifiedData || {}).map(([plantAddress, facility]) => (
          <VerificationProjectCard key={plantAddress} facility={facility} link={`/third-party/non-green/web3/${plantAddress}`} loading={loading} isComment={true} />
        ))}

        {/* Rest of your existing verified projects code remains the same */}
        {value === 1 && greenBasicFacilitiesVerified?.map((facility, index) => (
          // ... your existing verified projects code
          <div className="verification_card">
            {/* ... existing content */}
            <div>Verified Green Basic Project </div>
          </div>
        ))}

        {/* Loading skeleton and modals */}
        {generalLoading && (
          <div>load </div>
          // ... your existing loading skeleton
        )}

        {modalOpen && (
          <div> Open </div>

          // ... your existing modal
        )}

        {modalOpenTwo && (
          <div> Open Two </div>
          // ... your existing modal
        )}
      </div>
    </div>
  );
};

export default Verification;
